<nav class="navbar-menu" [class.navbar-menu--collapsed]="collapsed">
  @for (item of buttons; track item.path) {
    @if (item.type === ENavbarItemType.Group) {
      <a
        class="menu-item menu-group"
        [class.menu-group--active]="item | isParentActive: currentUrl()"
        [attr.data-element-id]="item.elementId"
        (click)="onGroupItemClick(item.path)">
        @if (item.icon) {
          <mat-icon [svgIcon]="item.icon"></mat-icon>
        }
        @if (!collapsed) {
          <span>{{ item.label | translate }}</span>
          <mat-icon
            class="expand-icon"
            [class.expand-icon--up]="isExpanded(item.path)"
            svgIcon="navbar-right">
          </mat-icon>
        }
      </a>

      @if (isExpanded(item.path)) {
        <div class="children" [class.children--hidden]="collapsed" @expandCollapse>
          @for (child of item.children; track $index) {
            @if (child.type === ENavbarItemType.Header) {
              @if (!collapsed) {
                <span class="menu-item-header">{{ child.label | translate }}</span>
              }
            } @else {
              <a
                [routerLink]="child.path"
                [class.menu-item-child--active]="child | isChildActive: currentUrl()"
                class="menu-item-child"
                [attr.data-element-id]="child.elementId">
                @if (child.icon) {
                  <mat-icon [svgIcon]="child.icon"></mat-icon>
                }
                {{ child.label | translate }}
              </a>
            }
          }
        </div>
      }
    } @else {
      <a
        [routerLink]="item.path"
        [class.menu-item--active]="item | isChildActive: currentUrl() : activeOverride()"
        class="menu-item"
        [attr.data-element-id]="item.elementId">
        <mat-icon *ngIf="item.icon" [svgIcon]="item.icon"></mat-icon>
        @if (!collapsed) {
          <span>{{ item.label | translate }}</span>
        }
      </a>
    }
  }
</nav>
